import { Fade } from 'reactstrap';

// Reactstrap 9.x ships Fade as a function component without setting
// `Fade.defaultProps`, but `PopperContent` reads `{...Fade.defaultProps}`
// to seed its own default `transition` prop. The spread of `undefined`
// becomes `{}`, so the downstream Fade renders with `timeout: undefined`
// and PropTypes complains. Backfilling defaultProps here fixes every
// Tooltip / Popover / Dropdown without per-instance changes.
//
// Safe to remove once we upgrade reactstrap to a release that sets
// Fade.defaultProps natively (or migrates away from defaultProps on
// function components).
const FADE_TIMEOUT_MS = 150; // matches reactstrap's TransitionTimeouts.Fade

if (!(Fade as any).defaultProps?.timeout) {
  (Fade as any).defaultProps = {
    ...((Fade as any).defaultProps || {}),
    timeout: FADE_TIMEOUT_MS,
    appear: true,
    enter: true,
    exit: true,
    in: true
  };
}
